// Public API - Simple shared library with no configuration needed!
// Email workflow service - handles opening email composer modal
export * from './lib/email-workflow.service';

// Row action functions - pass namespace as parameter like other integrations
export * from './lib/email-row-actions';

// Send email component - standalone component for composing emails
export * from './lib/send-email/send-email.component';

// Send email service - handles draft email functionality
export * from './lib/send-email/send-email.service';

// Constants and types
export * from './lib/send-email/constants';
